import React from "react";
import { SvgIcon, SvgIconProps } from "@material-ui/core";
import { DATATEST } from "constants/integration";

const Card = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} data-test={DATATEST.PROFILE.GRID_VIEW_TYPES.CARD}>
            <path d="M22,2H2C1.4,2,1,2.4,1,3v7c0,0.6,0.4,1,1,1h20c0.6,0,1-0.4,1-1V3C23,2.4,22.6,2,22,2z" />
            <path d="M22,13H2c-0.6,0-1,0.4-1,1v7c0,0.6,0.4,1,1,1h20c0.6,0,1-0.4,1-1v-7C23,13.4,22.6,13,22,13z" />
        </SvgIcon>
    );
};

export default Card;
